var map = {
	"./ankor.png": 5044,
	"./ayalon.svg": 3945,
	"./fenix.svg": 7477,
	"./hachshara.svg": 8840,
	"./haklay.svg": 2269,
	"./harel.svg": 7539,
	"./klal.svg": 8621,
	"./menora.svg": 2347,
	"./migdal.svg": 4399,
	"./shlomo.svg": 6885,
	"./shomera.svg": 9908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2847;